export default "__VITE_PUBLIC_ASSET__f7fa410c__"